export enum FloridaVehicleConfiguration {
  truckTractorSemitrailerHauling = 'truckTractorSemitrailerHauling',
  dromedaryBox = 'dromedaryBox',
  saddlemount = 'saddlemount',
  kingpinSetting = 'kingpinSetting',
  straightTruckOrTrailerCarrying = 'straightTruckOrTrailerCarrying',
  straightTruckHauling = 'straightTruckHauling',
  mobileHome = 'mobileHome',
  sealedContainer = 'sealedContainer',
  wreckerTowing = 'wreckerTowing',
  selfPropelled = 'selfPropelled',
  innerBridge = 'innerBridge',
  automobileTransporter = 'automobileTransporter',
  naturalGasFueledEngine = 'naturalGasFueledEngine',
  fluidMilkProduct = 'fluidMilkProduct',
  towawayTrailerTransporter = 'towawayTrailerTransporter',
  tandemTrailers = 'tandemTrailers',
  evergladesTandems = 'evergladesTandems',
}

export const FloridaVehicleConfigurationValues = Object.values(
  FloridaVehicleConfiguration,
);
